import React from "react";
import { siteContent } from "../../data/content";
import "./Episodes.css";

export const Episodes = (props) => {
  const handleVideoClick = (youtubeUrl) => {
    if (youtubeUrl) {
      window.open(youtubeUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div id="youtube" className="episodes-section">
      <div className="container">
        <div className="episodes-header">
          <div className="episodes-badge">
            <span className="badge-text">YouTube</span>
          </div>
          <h2 className="episodes-title">Derniers épisodes</h2>
          <p className="episodes-subtitle">
            Chaque semaine sur YouTube, Valérie Perez reçoit une femme (ou un homme engagé)
            pour parler de vie, de résilience, de choix, de féminisme.
          </p>
        </div>

        <div className="episodes-stats">
          <div className="stat-card">
            <div className="stat-number">115</div>
            <div className="stat-label">Vidéos</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">500K+</div>
            <div className="stat-label">Vues totales</div>
          </div>
        </div>

        <div className="episodes-grid">
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={i}
                  className="episode-card"
                  onClick={() => handleVideoClick(d.youtubeUrl)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="episode-thumbnail">
                    <div className="video-wrapper">
                      <iframe
                        src={d.youtubeUrl}
                        title={d.title || `episode-${i}`}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        loading="lazy"
                      ></iframe>
                    </div>
                    {d.duration && <div className="episode-duration">{d.duration}</div>}
                  </div>
                  <div className="episode-content">
                    <h3 className="episode-title">{d.title}</h3>
                  </div>
                  <div className="episode-overlay">
                    <div className="play-button">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8 5v14l11-7z" fill="currentColor"/>
                      </svg>
                    </div>
                  </div>
                </div>
              ))
            : Array.from({ length: 6 }, (_, i) => (
                <div key={i} className="episode-card skeleton">
                  <div className="episode-thumbnail skeleton-thumbnail"></div>
                  <div className="episode-content">
                    <div className="skeleton-title"></div>
                    <div className="skeleton-meta"></div>
                  </div>
                </div>
              ))}
        </div>

        <div className="episodes-cta">
          <a
            href="https://youtube.com/@destinsdefemmes"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
          >
            <span>Voir tous les épisodes</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>

        {/* Interview i24 */}
        {siteContent.instagramReels
          .filter((reel) => reel.type === "interview")
          .map((reel, i) => (
            <div key={i} className="episodes-instagram-section">
              <h3 className="episodes-instagram-title">{reel.title}</h3>
              <div className="episodes-instagram-grid">
                <div className="episodes-instagram-embed">
                  <iframe
                    src={`${reel.url}embed/`}
                    title={reel.title}
                    allowFullScreen
                    scrolling="no"
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </div>
          ))}

        {/* Liens Twitter / X */}
        {siteContent.instagramReels
          .filter((item) => item.type === "twitter")
          .map((item, i) => (
            <div key={i} className="episodes-twitter-section">
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="twitter-card"
              >
                <div className="twitter-card-icon">
                  <svg viewBox="0 0 24 24" width="32" height="32" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </div>
                <div className="twitter-card-content">
                  <h3 className="twitter-card-title">{item.title}</h3>
                  <span className="twitter-card-link">Voir sur X</span>
                </div>
                <div className="twitter-card-arrow">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </a>
            </div>
          ))}
      </div>
    </div>
  );
};

